import { useQuery } from '@tanstack/react-query';
import { InfrastructureProjectsApi } from 'osep-generator-service-client-v1';
import { IAS_PROJECT_TEMPLATE_README_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useInfraProjectTemplateReadme(
  projectId: string,
  templateName: string,
) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const cli = useQuery({
    queryKey: [IAS_PROJECT_TEMPLATE_README_QUERY_KEY, projectId, templateName],
    queryFn: async () => {
      const config = await getApiConfig();
      const infraApi = new InfrastructureProjectsApi(
        config,
        undefined,
        axiosInstance,
      );
      const result = (
        await infraApi.getInfrastructureProjectTemplateReadme(
          projectId,
          templateName,
        )
      ).data;

      return result;
    },
  });
  return cli;
}

export default useInfraProjectTemplateReadme;
